import { EinLetterTooltip } from '../PracticeProfileTooltips'

import { UploadItem } from './UploadItem'

import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

export const FormEinLetterUploadItem = ({
  businessEntity,
  uploadButtonOnly,
}: {
  businessEntity?: string
  uploadButtonOnly?: boolean
}) => {
  return (
    <UploadItem
      label="EIN Letter"
      popUpContent={<EinLetterTooltip />}
      documentCategory={UserDocumentCategoryIdentifier.einDocuments}
      additionalTrackingProperties={{
        document_category: 'ein_letter',
        business_entity: businessEntity,
      }}
      uploadButtonOnly={uploadButtonOnly}
    />
  )
}
